import ScoreWindow from './ScoreWindow';
export default ScoreWindow;